import { EventEmitter, Injectable, Output } from '@angular/core';
import { TranslateService } from '../../../core/translation';
import { LoadingService } from '../../../shared/loading/loading.service';
import { MessageService } from '../../../shared/message/message.service';

declare let Dropbox: any;

@Injectable({
  providedIn: 'root',
})
export class DropboxChooserService {

  @Output() finish: EventEmitter<any> = new EventEmitter;

  primaryExtension: string;

  extensions: Array<string>;
  constructor(
    public _message: MessageService,
    public loading: LoadingService,
    public _translate: TranslateService) {}

  loadDropbox() {
    if (this.isSupported()) {
      const options = {
        success: (file) => {
          this.finish.emit(file);
        },
        cancel: function () {},
        linkType: 'direct', // or "direct"
        multiselect: true, // or true
        extensions: this.extensions,
        folderselect: false, // or true
      };
      Dropbox.choose(options);
    }
  }

  async proceesFile(file) {
    try {
      let response = await fetch(file);
      let blob = await response.blob();
      return blob;
    } catch (error) {
      this._message.showError(this._translate.instant('error_proccess_file'));
      this.loading.set(false);
    }
  }

  isSupported() {
    return Dropbox.isBrowserSupported();
  }

  setDropboxConfig(primaryExtension) {
    this.primaryExtension = primaryExtension;

    const extensions = this.primaryExtension.toLowerCase();
    const ext = this.removeDuplicateCharacters(extensions);

    switch (true) {
      case ext.includes('xml') && ext.includes('pdf'):
        this.extensions = ['.pdf', '.xml'];
        break;
      case ext.includes('pdf') && !ext.includes('xml'):
        this.extensions = ['.pdf'];
        break;
      case !ext.includes('pdf') && ext.includes('xml'):
        this.extensions = ['.xml'];
        break;
      case ext === '':
        this.extensions = [];
        break;
    }
  }

  removeDuplicateCharacters(word) {
    return word
      .split('')
      .filter(function(item, pos, self) {
        return self.indexOf(item) == pos;
      })
      .join('');
  }
}
